export type AiStrategyTradesHistoryMode = 'all' | 'signals_in' | 'signals_out';

export class AiStrategyTradesHistoryRequestModel {
    public fromDate: string = '';   // YYYYMMDD format
    public toDate: string = '';     // YYYYMMDD format
    public segment: string = 'all';
    public historyMode: AiStrategyTradesHistoryMode = 'all';
    public tradeId: string = '';
}
